 <!-- <ng-template #loading> -->
  <div class="spinner"></div>
  <!-- <div class="loading-text">Loading...</div> -->
<!-- </ng-template> -->